export const DARK_MODE_ENUM = {
  TRUE: "true",
  FALSE: "false",
};
